import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface NorthStarProps {
  color?: string;
  style?: React.CSSProperties;
  height?: string;
  width?: string;
}

export default function NorthStarIcon({ color = RoutalPalette.neutral00, height, width, style = {} }: NorthStarProps) {
  return (
    <SvgIcon
      viewBox="0 0 12 12"
      style={{ fill: color, strokeWidth: 0, height: height ?? `14px`, width: width ?? `14px`, ...style }}
    >
      <path d="M.46,6.3c2.89,0,5.24,2.35,5.24,5.24.16.18.44.18.61,0,0-2.89,2.35-5.24,5.24-5.24.18-.16.18-.44,0-.61-2.89,0-5.24-2.35-5.24-5.24-.16-.18-.44-.18-.61,0C5.7,3.35,3.35,5.7.46,5.7c-.18.16-.18.44,0,.61Z" />
    </SvgIcon>
  );
}
